import aguaNevadaPequena from '../assets/Extras/agua-nevada-saborizada-pequena.png';
import papasFritas from '../assets/Extras/Racion de Papas fritas Delivery.png';

function normalizeName(name) {
  return String(name || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Imagen local cuando el archivo publicado en la API no carga.
 * @param {string} name
 * @returns {string|null}
 */
export function fallbackImageForExtra(name) {
  const n = normalizeName(name);
  if (n.includes('AGUA NEVADA') && n.includes('PEQUE')) return aguaNevadaPequena;
  if (n.includes('PAPA')) return papasFritas;
  return null;
}

/** Extras de demostración (pizza) que no se venden en el restaurante. */
export function isRestaurantExtra(extra) {
  if (!extra) return false;
  if (extra.is_active === false || extra.is_active === 0) return false;
  const name = normalizeName(extra.title ?? extra.name);
  if (!name) return false;
  return !/QUESO EXTRA|PEPPERONI|CHAMPI|ACEITUNA|BORDE RELLENO/.test(name);
}
